var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartLightLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.68,
    height: 43.116,
    viewBox: "0 0 44.68 43.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-heart",
    "data-name": "Icon ionic-ios-heart",
    d: "M35.3,3.937h-.1A11.947,11.947,0,0,0,25.215,9.4a11.947,11.947,0,0,0-9.975-5.46h-.1A11.871,11.871,0,0,0,3.375,15.8c0,3.885,1.7,9.4,5.019,13.934,6.321,8.642,16.821,16.2,16.821,16.2s10.5-7.56,16.821-16.2C45.354,25.2,47.055,19.687,47.055,15.8A11.871,11.871,0,0,0,35.3,3.937Z",
    transform: "translate(-2.875 -3.438)",
    fill: "none",
    stroke: "#807ce0",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLightLg);
export default __webpack_public_path__ + "static/media/heart-light-lg.f24399a1edd806514b59f3a1963a1750.svg";
export { ForwardRef as ReactComponent };